import { motion } from "framer-motion";

const CHAPTERS = [
    {
        number: "01",
        title: "Protection",
        body: (
            <>
                <a
                    href="https://insurance.truthexcellencegroup.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-slate-300 underline decoration-amber-400/40 underline-offset-4 transition-colors hover:text-amber-300"
                >
                    Truth Insurance
                </a>{" "}
                safeguards what matters most — life, health, and property — so every legacy is
                built on solid ground.
            </>
        ),
    },
    {
        number: "02",
        title: "Gathering",
        body: "The Truth Spot and Activate The Crowd turn attention into action: events, culture, community, and live fan experiences.",
    },
    {
        number: "03",
        title: "Movement",
        body: "Truth Travels and Truth Fleet move people in premium fashion — explore more, experience more, live more.",
    },
    {
        number: "04",
        title: "Voice",
        body: "Spit Your Truth amplifies spoken word, real stories, and raw truth — with real impact.",
    },
];

export default function Manifesto() {
    return (
        <section id="manifesto" className="relative scroll-mt-24 px-5 py-24 sm:py-32" aria-label="Manifesto">
            <div className="mx-auto max-w-6xl">
                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                    className="eyebrow mb-4"
                >
                    The Manifesto
                </motion.p>
                <motion.h2
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.9, delay: 0.1 }}
                    className="font-display max-w-2xl text-2xl font-medium tracking-tight text-slate-100 sm:text-3xl lg:text-4xl"
                >
                    Excellence is not a department. <span className="text-gold-gradient">It is the standard.</span>
                </motion.h2>

                <div className="mt-16 space-y-0">
                    {CHAPTERS.map((c, i) => (
                        <motion.div
                            key={c.number}
                            initial={{ opacity: 0, y: 36 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                            className={`flex flex-col gap-4 border-t border-amber-400/10 py-10 sm:flex-row sm:items-baseline sm:gap-12 ${
                                i % 2 === 1 ? "sm:pl-24" : ""
                            }`}
                        >
                            <span className="chapter-number shrink-0 text-6xl font-semibold sm:text-7xl" aria-hidden="true">
                                {c.number}
                            </span>
                            <div className="max-w-xl">
                                <h3 className="font-display text-xl font-medium tracking-wide text-amber-200/90 uppercase sm:text-2xl">
                                    {c.title}
                                </h3>
                                <p className="mt-3 text-base leading-relaxed text-slate-400">{c.body}</p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
